import { ReactNode, useEffect, useMemo, useState } from "react";

import { fetchPartnerBranding } from "app/api";
import { searchConst } from "app/constants/query";
import { PartnerBranding } from "app/types/services/branding";
import { applyBrandingToDocument } from "app/utils/apply-branding";
import { applyBrandingToWalletModal } from "config/appkit";
import { BrandingContext } from "./BrandingContext";

interface BrandingProviderProps {
  children: ReactNode;
}

export default function BrandingProvider({ children }: BrandingProviderProps) {
  const [branding, setBranding] = useState<PartnerBranding | null>(null);
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const params = new URLSearchParams(window.location.search);

    const token = params.get(searchConst.token);
    if (token) sessionStorage.setItem("sessionToken", token);

    fetchPartnerBranding(params.get(searchConst.partnerId)).then((result) => {
      if (cancelled) return;
      applyBrandingToDocument(result);
      applyBrandingToWalletModal(result?.brandPrimaryColor);
      setBranding(result);
      setIsReady(true);
    });

    return () => {
      cancelled = true;
    };
  }, []);

  const value = useMemo(() => ({ branding, isReady }), [branding, isReady]);

  // Neutral spinner (not the Relm loader gif) while we find out whose checkout this is.
  if (!isReady) {
    return (
      <div className="flex min-h-screen w-full items-center justify-center" aria-busy="true">
        <span className="h-[36px] w-[36px] animate-spin rounded-full border-[3px] border-[#E6E2F0] border-t-[#8476A5]" />
      </div>
    );
  }

  return <BrandingContext.Provider value={value}>{children}</BrandingContext.Provider>;
}
